<template>
  <v-container class="pt-0" fluid>
    <v-row align="center">
      <v-col cols="12">
        <manutencao-mapeamentos-data-table :loading="loading" :items="items" @reloadItemsTabela="getMapeamento()" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import Mapeamento from '@/services/MapeamentoService.js';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      ManutencaoMapeamentosDataTable: () => import('@/components/mapeamentos/ManutencaoMapeamentoDataTable.vue')
    },

    mixins: [tourMixins],

    data: () => ({
      items: [],
      loading: false,
      arrTour: [
        {
          element: '#mapeamentos-search',
          intro: 'Neste campo você poderá pesquisar por mapeamentos já existentes.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#action-remover-mapeamento',
          intro: 'Clicando neste ícone você poderá excluir o mapeamento',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#actions-mapeamento',
          intro:
            'Aqui você acessa outras opções para os mapeamentos, como ver mais detalhes, editar ou replicá-lo para outros sistemas.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ]
    }),

    created() {
      this.getMapeamento();
    },

    methods: {
      getMapeamento() {
        this.loading = true;
        this.items = [];

        Mapeamento.getMapeamento()
          .then((resp) => {
            this.items = resp.data.mapeamentos;
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar Mapeamentos.', '', { position: 'topRight' });
          })
          .finally(() => {
            ((this.loading = false), this.iniciarTourPagina());
          });
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        let arrTourFormatted = this.items.length ? this.arrTour : this.arrTour.splice(0, 1);
        this.iniciarTour(arrTourFormatted);
      }
    }
  };
</script>